export default __webpack_public_path__ + "static/media/theme-science.5ce1d1e8.png";